export default __webpack_public_path__ + "static/media/acm_action_blur_text.5e6820c5.png";